<template>
  <span class="badge">{{ value }}</span>
</template>

<script>
export default {
  name: 'badge',
  props: ['value']
}
</script>

<style scoped>
.badge {
  position: relative;
  min-width: 85px;
  min-height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: #ccc;
  font-size: 12px;
  font-weight: 600;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// badge.vue?31cb2898